import {
  GET_CERTIFICATE_ALIASES_URL,
  GET_CERTIFICATE_BY_VMID_URL,
  GET_PRODUCT_CERTIFICATE_URL,
  PRODUCT_REPLACE_CERTIFICATE_PRE_CHECK_URL,
  PRODUCT_REPLACE_CERTIFICATE_URL
} from '../../../constants/ApiUri';

import { AliasVmid } from '../../../types/Common';
import { Http } from 'vrlcm-gui-utils';
import { ReplaceCertificatePayload } from '../../../components/environments/actions/replace-certificate/types';
import { RequestId, Certificate } from 'vrlcm-gui-types';

export default class CertificateStepAPI {
  public static getCertificateAliases = async (): Promise<AliasVmid[]> => {
    const response = await Http.get(GET_CERTIFICATE_ALIASES_URL);
    return response.data;
  };
  public static getProductCertificate = async (
    environmentId: string,
    productId: string,
    component: string
  ): Promise<any> => {
    const response = await Http.get(
      GET_PRODUCT_CERTIFICATE_URL(productId, environmentId, component)
    );
    return response.data;
  };
  public static getCertificateByVmid = async (
    vmid: string
  ): Promise<Certificate> => {
    const response = await Http.get(GET_CERTIFICATE_BY_VMID_URL(vmid));
    return response.data;
  };

  public static replaceCertificatePreCheck = async (
    environmentId: string,
    productId: string,
    payload: ReplaceCertificatePayload,
    tenantId?: string
  ) => {
    const response = await Http.post<RequestId>(
      PRODUCT_REPLACE_CERTIFICATE_PRE_CHECK_URL(
        productId,
        environmentId,
        tenantId
      ),
      payload
    );
    return response.data;
  };
  public static replaceCertificate = async (
    environmentId: string,
    productId: string,
    payload: ReplaceCertificatePayload,
    tenantId?: string
  ) => {
    const response = await Http.post<RequestId>(
      PRODUCT_REPLACE_CERTIFICATE_URL(productId, environmentId, tenantId),
      payload
    );
    return response.data.requestId;
  };
}
